// removed by extract-text-webpack-plugin
module.exports = {"container":"notifications__container___19Yzg","icon":"notifications__icon___1hgC_"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/notifications.scss
// module id = 1347
// module chunks = 0